import type {PropsWithChildren} from 'react';

const DialogContentText = (
  props: PropsWithChildren & {className?: string},
): React.JSX.Element => {
  return (
    <p
      {...props}
      className={props.className}
    >
      {props.children}
    </p>
  );
};

export {DialogContentText};
